import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { type FormData, MAX_CHARS } from "./types";

// ─── Step 4: A Few Last Things ────────────────────────────────────────────────

function StepGoodToKnow({
  data,
  onChange,
  onBack,
  onContinue,
  editMode = false,
}: {
  data: FormData;
  // eslint-disable-next-line no-unused-vars
  onChange: (_patch: Partial<FormData>) => void;
  onBack: () => void;
  onContinue: () => void;
  editMode?: boolean;
}) {
  const hasContent = data.additionalNotes.trim().length > 0 || data.idealCandidateDescription.trim().length > 0;

  return (
    <div className="rah-form-card">
      <div className="rah-form-card__header">
        <h2 className="rah-form-card__title">A few last things</h2>
        <p className="rah-form-card__subtitle">Help us understand your preferences better</p>
      </div>

      <div className="rah-form-card__fields">
        {/* ── What should we avoid? ── */}
        <div className="rah-form-card__field-group" style={{ gap: 4 }}>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="rah-avoid-textarea" className="rah-form-card__field-label">
            What should we avoid? (optional)
          </label>
          <textarea
            id="rah-avoid-textarea"
            className="rah-textarea"
            rows={6}
            placeholder="Industries, working styles, or traits that haven't worked well in the past"
            value={data.additionalNotes}
            onChange={(e) => {
              if (e.target.value.length <= MAX_CHARS) onChange({ additionalNotes: e.target.value });
            }}
          />
          <div className="rah-form-card__char-count">
            {data.additionalNotes.length}/ {MAX_CHARS} characters
          </div>
        </div>

        {/* ── Anything else we should know? ── */}
        <div className="rah-form-card__field-group" style={{ gap: 4 }}>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="rah-extra-textarea" className="rah-form-card__field-label">
            Anything else we should know? (optional)
          </label>
          <textarea
            id="rah-extra-textarea"
            className="rah-textarea"
            rows={6}
            placeholder="Timezone needs, certifications, availability, or anything else on your mind"
            value={data.idealCandidateDescription}
            onChange={(e) => {
              if (e.target.value.length <= MAX_CHARS) onChange({ idealCandidateDescription: e.target.value });
            }}
          />
          <div className="rah-form-card__char-count">
            {data.idealCandidateDescription.length}/ {MAX_CHARS} characters
          </div>
        </div>
      </div>

      <div className="rah-form-card__footer">
        <button type="button" className="rah-form-card__back-btn" onClick={onBack}>
          <ChevronLeftIcon sx={{ fontSize: 22 }} />
          Back
        </button>
        {editMode && (
          <button type="button" className="rah-form-card__continue-btn" onClick={onContinue}>
            Save
            <ChevronRightIcon sx={{ fontSize: 22 }} />
          </button>
        )}
        {!editMode && hasContent && (
          <button type="button" className="rah-form-card__continue-btn" onClick={onContinue}>
            Review request
            <ChevronRightIcon sx={{ fontSize: 22 }} />
          </button>
        )}
        {!editMode && !hasContent && (
          <button type="button" className="rah-personality__skip-btn" onClick={onContinue}>
            Skip this step
          </button>
        )}
      </div>
    </div>
  );
}

export default StepGoodToKnow;
